module.exports = __webpack_public_path__ + "img/1-3.bd6d5940.png";